"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var messageCode_1 = require("../../utils/messageCode");
var BaseMessage = (function (_super) {
    __extends(BaseMessage, _super);
    function BaseMessage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BaseMessage.prototype.render = function () {
        var _a = this.props, code = _a.code, children = _a.children, fallbackCode = _a.fallbackCode, args = _a.args, className = _a.className, i18n = _a.i18n;
        var messages = i18n ? i18n.messages : this.props.messages;
        if (!messages) {
            console.error('localization reducer does not have a message set');
            return react_1.default.createElement("span", null);
        }
        if (children) {
            return react_1.default.createElement("span", { className: className }, messageCode_1.getMessageJsx(messages, code, react_1.default.Children.toArray(children)));
        }
        var message = messageCode_1.getMessage(messages, code, args) || (fallbackCode && messageCode_1.getMessage(messages, fallbackCode, args));
        if (!message) {
            console.info('message code not found. code: %s; fallback: %s', code, fallbackCode);
        }
        message = message || code;
        try {
            if (process && process.env && process.env.REACT_APP_ALLOW_MESSAGE_DANGEROUS_SET) {
                return react_1.default.createElement("span", { className: className, dangerouslySetInnerHTML: { __html: message } });
            }
        }
        catch (e) {
            console.error(e);
        }
        return react_1.default.createElement("span", { className: className }, message);
    };
    return BaseMessage;
}(react_1.PureComponent));
exports.BaseMessage = BaseMessage;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQmFzZU1lc3NhZ2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY2xpZW50L21lc3NhZ2UvQmFzZU1lc3NhZ2UudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSw2Q0FBMkM7QUFDM0MsdURBQWtFO0FBYWxFO0lBQWlDLCtCQUErQjtJQUFoRTs7SUFvQ0EsQ0FBQztJQW5DRyw0QkFBTSxHQUFOO1FBQ1UsSUFBQSxlQUFrRSxFQUFqRSxjQUFJLEVBQUUsc0JBQVEsRUFBRSw4QkFBWSxFQUFFLGNBQUksRUFBRSx3QkFBUyxFQUFFLGNBQWtCLENBQUM7UUFFekUsSUFBTSxRQUFRLEdBQUcsSUFBSSxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsUUFBUSxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDLFFBQVEsQ0FBQztRQUM1RCxJQUFJLENBQUMsUUFBUSxFQUFFO1lBQ1gsT0FBTyxDQUFDLEtBQUssQ0FBQyxrREFBa0QsQ0FBQyxDQUFDO1lBQ2xFLE9BQU8sMkNBQVEsQ0FBQztTQUNuQjtRQUdELElBQUksUUFBUSxFQUFFO1lBQ1YsT0FBTyx3Q0FBTSxTQUFTLEVBQUUsU0FBUyxJQUFHLDJCQUFhLENBQUMsUUFBUSxFQUFFLElBQUksRUFBRSxlQUFLLENBQUMsUUFBUSxDQUFDLE9BQU8sQ0FBQyxRQUFRLENBQUMsQ0FBQyxDQUFRLENBQUM7U0FDL0c7UUFFRCxJQUFJLE9BQU8sR0FBRyx3QkFBVSxDQUFDLFFBQVEsRUFBRSxJQUFJLEVBQUUsSUFBSSxDQUFDLElBQUksQ0FBQyxZQUFZLElBQUksd0JBQVUsQ0FBQyxRQUFRLEVBQUUsWUFBWSxFQUFFLElBQUksQ0FBQyxDQUFDLENBQUM7UUFFN0csSUFBSSxDQUFDLE9BQU8sRUFBRTtZQUNWLE9BQU8sQ0FBQyxJQUFJLENBQUMsZ0RBQWdELEVBQUUsSUFBSSxFQUFFLFlBQVksQ0FBQyxDQUFDO1NBQ3RGO1FBRUQsT0FBTyxHQUFHLE9BQU8sSUFBSSxJQUFJLENBQUM7UUFHMUIsSUFBSTtZQUNBLElBQUksT0FBTyxJQUFJLE9BQU8sQ0FBQyxHQUFHLElBQUksT0FBTyxDQUFDLEdBQUcsQ0FBQyxxQ0FBcUMsRUFBRTtnQkFFN0UsT0FBTyx3Q0FBTSxTQUFTLEVBQUUsU0FBUyxFQUFFLHVCQUF1QixFQUFFLEVBQUMsTUFBTSxFQUFFLE9BQU8sRUFBQyxHQUFJLENBQUM7YUFFckY7U0FDSjtRQUFDLE9BQU8sQ0FBQyxFQUFFO1lBQ1IsT0FBTyxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQztTQUNwQjtRQUVELE9BQU8sd0NBQU0sU0FBUyxFQUFFLFNBQVMsSUFBRyxPQUFPLENBQVEsQ0FBQztJQUN4RCxDQUFDO0lBQ0wsa0JBQUM7QUFBRCxDQUFDLEFBcENELENBQWlDLHFCQUFhLEdBb0M3QztBQXBDWSxrQ0FBVyJ9